// REACT_APP_ENV distingue stage da prod: NODE_ENV è forzato a "production" da CRA
// per qualsiasi `react-scripts build`, quindi non basta a scegliere l'host giusto.
const API_URLS = {
  staging: 'https://stage-webapp.wine2trace.com/api',
  production: 'https://webapp.wine2trace.com/api',
};
export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? API_URLS[process.env.REACT_APP_ENV] || API_URLS.production
    : 'http://localhost:3500/api';
